export enum FileImportModes {
  Upsert = "Upsert",
  Recreate = "Recreate",
}

export enum FileImportModesOptions {
  Upsert = "Add new data to existing records",
  Recreate = "Overwrite all data",
}
